import { ButtonType, StyleVariant } from "./types";
import { InputType } from "storybook/internal/csf";
import { FIXED_HEIGHT_ROW_STYLES } from "../detailedPages/styles";

export const styleVariants: StyleVariant[] = [
  "newPage",
  "detailPage",
  "slideOver",
  "srLabel",
];

export const styleVariantControls: InputType = {
  control: { type: "select" },
  options: styleVariants,
};

export const NAMED_WRAPPER_STYLES =
  "flex max-w-full items-center justify-between py-2 sm:gap-4";

export const NAMED_NARROW_INPUT_STYLES: Record<StyleVariant, string> = {
  newPage: "h-14",
  detailPage: FIXED_HEIGHT_ROW_STYLES,
  slideOver: "min-h-14 max-h-16",
  srLabel: "h-10",
};

export const buttonTypes: ButtonType[] = [
  "primary",
  "secondary",
  "tetriary",
  "disabled",
  "danger",
  "ghost",
  "active",
  "inactive",
  "iconOnly",
  "custom",
];
